// extracted by mini-css-extract-plugin
export default {"productCarousel":"g0-z"};